import React from "react";
import { Box, Text, useColorModeValue } from "@chakra-ui/react";

const EmptyState = ({ message = "No records found." }) => {
  const bg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  return (
    <Box
      bg={bg}
      borderWidth="1px"
      borderColor={borderColor}
      borderRadius="lg"
      p={8}
      textAlign="center"
    >
      <Text color="gray.500">{message}</Text>
    </Box>
  );
};

export default EmptyState;
